// import { Button, Typography } from '@wbk/ui';
import { WebSection } from '@wbk/contentful/api';
import { parseSectionItem } from '@wbk/contentful';
import GuideCard from '../guides/GuideCard';
import ScrollTitle from '../ui/ScrollTitle';
type Props = {
  section: WebSection;
};
export default function Guide({ section }: Props) {
  return (
    <section
      id='booklet-section'
      className='container-padding container flex flex-col items-center gap-4 space-y-8 px-3'
    >
      <div className='flex flex-col gap-4 text-center lg:flex-row lg:items-end lg:justify-between'>
        <ScrollTitle title={section.title} noColor />
      </div>
      <div className='flex w-full flex-wrap justify-center gap-6 sm:gap-8 md:gap-10 lg:gap-12 xl:gap-16'>
        {section.contentCollection.items.map((item, index) => {
          const parsedItem = parseSectionItem({ item, locale: 'en' });
          if (!parsedItem) return null;
          return (
            <GuideCard
              key={index}
              title={parsedItem.title}
              description={parsedItem.subtitle || 'Discover rich traditions'}
              image={parsedItem.image11}
              href={parsedItem.href}
              buttonText={parsedItem?.label}
              homepage
              className='max-w-auto !h-[640px] sm:max-w-[480px]'
            />
          );
        })}
      </div>
    </section>
  );
}
